export default __webpack_public_path__ + "static/media/logo-member-dashboard.295a35fd.svg";